import { useState, useEffect } from "react";
import CustomDropdown from "../../components/customdropdown/CustomDropdown";

const Test = () => {
  const options = [
    { value: "apple", label: "Apple 🍎" },
    { value: "banana", label: "Banana 🍌" },
    { value: "orange", label: "Orange 🍊" },
  ];

  const [selected, setSelected] = useState("");

  return (
    <div>
      <CustomDropdown
        options={options}
        value={selected}
        onChange={setSelected}
        placeholder="Choose a fruit"
      />
    </div>
  );
};

export default Test;
